import { compareCaptcha } from '@/api/channel-api.js'

// 检查验证码输入是否正确
export const CHECK_CODE = {
  valCode: [
    {
      validator: async (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入验证码'))
          return
        }
        let { result } = await compareCaptcha({
          code: value,
        })
        if (!result) {
          callback(new Error('验证码不正确，请重新输入'))
        } else {
          callback()
        }
      },
      trigger: 'blur',
      required: true,
    },
  ],
}
